import React, { useState, useEffect } from 'react'
import { Tabs, Tab } from 'carbon-components-react';
import NotesTab from '../IncidentDetails/Tabs/Notes/NotesTab';
import ResolutionTab from '../IncidentDetails/Tabs/Resolution/ResolutionTab';
import * as IncidentDetailsConstants from './IncidentDetailsPage/IncidentDetailsConstants';
import RCATabUser from './Tabs/RCATabUser';
import RemediationTabUser from './Tabs/RemediationTabUser';
import AssistanceTab from './Tabs/Assistance/AssistanceTab';

require("../IncidentDetails/Tabs/_tab-component.scss");

const IncidentsUserTabComponents = (props) => {
    const [actionable, setActionable] = useState();
    const actionSteps = props.somClassificationData.action_desc;
    const rcConfidence = props.somClassificationData.rc_confidence ? (props.somClassificationData.rc_confidence * 100).toFixed(2) : '-';
    const tickettypeConfidence = props.somClassificationData.tickettype_confidence ? (props.somClassificationData.tickettype_confidence * 100).toFixed(2) : '-';
    const ownerConfidence = props.somClassificationData.owner_confidence ? (props.somClassificationData.owner_confidence * 100).toFixed(2) : '-';
    const categoryConfidence = props.somClassificationData.category_confidence ? (props.somClassificationData.category_confidence * 100).toFixed(2) : '-';
    const actionConfidence = props.somClassificationData.action_confidence ? (props.somClassificationData.action_confidence * 100).toFixed(2) : '-';
    const actionTypeConfidence = props.somClassificationData.action_type_confidence ? (props.somClassificationData.action_type_confidence * 100).toFixed(2) : '-';
    const priorityConfidence = props.somClassificationData.priority_confidence ? (props.somClassificationData.priority_confidence * 100).toFixed(2) : '-';
    const [tabChanged, setTabChanged] = useState();

    useEffect(() => {
        switch(props.somClassificationData.actionable) {
            case 'UA':
                setActionable("User Actionable");
                break;
            case 'AGA':
                setActionable("Agent-Actionable");
                break;
            case 'AA':
                setActionable("Auto-Actionable");
                break;
            case 'NA':
                setActionable("No action");
                break;
            default:
                setActionable(props.somClassificationData.actionable);
                break;
        }
    }, [props.somClassificationData.actionable, props.incidentArray]);

    const getSelectedTab = (e, selectedTab) => {
        setTabChanged(selectedTab);
    };

    const getSystemUserDescription = (description, shortDescription,client) => {
        let combineDescription;
        if(description && shortDescription){
            combineDescription = description.concat(shortDescription);
            if(client === "Juniper"){
                combineDescription = combineDescription.slice(0, 500);
            }
        }
        return combineDescription;
    };

    return (
        <div className="container-tabs-story-wrapper--light tabs-size tab-full-width incidents-user-details">
            <Tabs scrollIntoView={false} type='container'>
                <Tab href="#" id="rcaTab" label={IncidentDetailsConstants.RootcauseAnalysis} onClick={(e) => getSelectedTab(e, 'rcaTab')}>
                    <div className="tab-content">
                        <RCATabUser  rcConfidence={rcConfidence} tickettypeConfidence={tickettypeConfidence} ownerConfidence={ownerConfidence}
                            categoryConfidence={categoryConfidence} priorityConfidence={priorityConfidence} predicted_rc={props.somClassificationData.predicted_rc}
                             tickettype={props.somClassificationData.tickettype} priority={props.somClassificationData.priority} predicted_owner={props.somClassificationData.predicted_owner} 
                             predicted_category={props.somClassificationData.predicted_category}  updateSomData={props.updateSomData} getClassificationStatus={props.getClassificationStatus} 
                             incidentArray={props.incidentArray} 
                            />
                    </div>
                </Tab>
                <Tab href="#" id="assistanceTab" label={IncidentDetailsConstants.Assistance} onClick={(e) => getSelectedTab(e, 'assistanceTab')}>
                    <div className="tab-content">
                        <AssistanceTab sysId={props.sysId} incidentId={props.incidentId} process={getSystemUserDescription(props.incidentArray.description, props.incidentArray.short_description, 
                            props.incidentArray.u_client)} client={props.client} />
                    </div>
                </Tab>
                <Tab href="#" id="remediationTab" label={IncidentDetailsConstants.Remediation} onClick={(e) => getSelectedTab(e, 'remediationTab')}>
                    <div className="tab-content">
                        <RemediationTabUser actionTypeConfidence={actionTypeConfidence} actionConfidence={actionConfidence} actionSteps={actionSteps} actionable={actionable} 
                        somClassificationData={props.somClassificationData} getClassificationStatus={props.getClassificationStatus} incidentArray={props.incidentArray}
                         updateSomData={props.updateSomData} process={getSystemUserDescription(props.incidentArray.description, props.incidentArray.short_description, 
                         props.incidentArray.u_client)} client={props.client} workspace={props.workspace}/>
                    </div>
                </Tab>
                <Tab href="#" id="notesTab" label={IncidentDetailsConstants.Notes} onClick={(e) => getSelectedTab(e, 'notesTab')}>
                    <div className="tab-content">
                        {tabChanged === 'notesTab' &&
                            <NotesTab sysId={props.sysId} incidentId={props.incidentId} workspace={props.workspace}
                                client={props.client} franchise={props.franchise} assignmentGroup={props.incidentArray && props.incidentArray.assignment_group && props.incidentArray.assignment_group.label ? props.incidentArray.assignment_group.label: ''} disableIncidentUpdate={props.disableIncidentUpdate} />
                        }
                    </div>
                </Tab>
                <Tab href="#" id="resolutionTab" label={IncidentDetailsConstants.Resolution} onClick={(e) => getSelectedTab(e, 'resolutionTab')}>
                    <div className="tab-content">
                        {tabChanged === 'resolutionTab' &&
                            <ResolutionTab sysId={props.sysId} incidentId={props.incidentId} disableIncidentUpdate={props.disableIncidentUpdate}
                                workspace={props.workspace} client={props.client} franchise={props.franchise}
                                getIncidentDetails={props.getIncidentDetails} incidentArray={props.incidentArray}/>
                        }
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}
export default IncidentsUserTabComponents
